import {DOWNLOAD_BINDING_CONTEXT_TYPE_ID} from './identifiers';

import type {
  BindingContextTypeDef,
  BindablePropertiesDef,
  TypeReferenceBuilder,
} from '@packages/systems/dynamo/source-types';

export const downloadType: BindingContextTypeDef = {
  entity: 'Entity',
  id: DOWNLOAD_BINDING_CONTEXT_TYPE_ID,
  label: 'Downloads',
  pluralLabel: 'Downloads',
  singularLabel: 'Download',
  iconName: 'product',
};

export function downloadBindableProperties<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindablePropertiesDef<EntityTRef, ListTRef> {
  return {
    type: typeReferenceBuilder.entityOf({
      entity: 'Entity',
      id: DOWNLOAD_BINDING_CONTEXT_TYPE_ID,
    }),
    bindableProperties: [
      {
        id: 'download-file-name',
        type: 'PlainText',
        label: 'File name',
        path: [{id: '', slug: 'name', type: 'PlainText'}],
        queryPath: [],
        meta: {
          singleLine: true,
          minLength: null,
          maxLength: null,
          required: true,
        },
        rendering: {strategy: 'client'},
      },
      {
        id: 'download-file-link',
        type: 'Link',
        label: 'File URL',
        path: [{id: '', slug: 'url', type: 'Link'}],
        queryPath: [],
        meta: {
          required: true,
        },
        rendering: {strategy: 'client'},
      },
    ],
  };
}
